import PropTypes from 'prop-types';
export const textPropTypes = {
  /**
   * The HTML code
   */
  html: PropTypes.string
};